import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PHONE_DISPLAY, EMAIL, CITY, openWhatsApp } from '../constants';

export default function ContactPage() {
  const navigate = useNavigate();

  return (
    <div style={{ paddingTop: 64 }}>

      {/* Header */}
      <section style={{ background: 'var(--cream)', padding: '60px 24px 48px', textAlign: 'center' }}>
        <div className="badge">📞 Get In Touch</div>
        <h1 className="section-title" style={{ textAlign: 'center' }}>Contact VRK Tech Academy</h1>
        <p className="section-sub" style={{ margin: '0 auto', textAlign: 'center' }}>
          Have questions? We're here to help — usually respond within minutes on WhatsApp.
        </p>
      </section>

      {/* Contact Cards */}
      <section className="section">
        <div className="container" style={{ maxWidth: 860 }}>

          <div className="grid-3" style={{ marginBottom: 36 }}>

            {/* WhatsApp */}
            <div className="card" style={{ textAlign: 'center', padding: '36px 24px', borderTop: '4px solid #25D366' }}>
              <img src="/whatsapp.png" alt="WhatsApp" style={{ height: 48, marginBottom: 16 }} />
              <h3 style={{ color: 'var(--navy)', fontWeight: 800, fontSize: 17, marginBottom: 6 }}>WhatsApp</h3>
              <p style={{ color: 'var(--gray)', fontSize: 14, marginBottom: 18 }}>
                Fastest way to reach us.<br />Usually reply within minutes.
              </p>
              <div style={{ fontWeight: 800, color: 'var(--navy)', fontSize: 15, marginBottom: 16 }}>{PHONE_DISPLAY}</div>
              <button
                style={{
                  background: '#25D366', color: '#fff', border: 'none', padding: '11px 22px',
                  borderRadius: 50, fontWeight: 800, fontSize: 14, cursor: 'pointer', fontFamily: 'Nunito,sans-serif',
                  transition: 'background 0.2s',
                }}
                onClick={() => openWhatsApp()}>
                Open WhatsApp →
              </button>
            </div>

            {/* Phone */}
            <div className="card" style={{ textAlign: 'center', padding: '36px 24px', borderTop: '4px solid var(--navy)' }}>
              <div style={{ fontSize: 40, marginBottom: 12 }}>📱</div>
              <h3 style={{ color: 'var(--navy)', fontWeight: 800, fontSize: 17, marginBottom: 6 }}>Phone Call</h3>
              <p style={{ color: 'var(--gray)', fontSize: 14, marginBottom: 18 }}>
                Prefer to talk? Give us a call during support hours.
              </p>
              <div style={{ fontWeight: 800, color: 'var(--navy)', fontSize: 15, marginBottom: 16 }}>{PHONE_DISPLAY}</div>
              <button
                style={{
                  background: 'var(--navy)', color: '#fff', border: 'none', padding: '11px 22px',
                  borderRadius: 50, fontWeight: 800, fontSize: 14, cursor: 'pointer', fontFamily: 'Nunito,sans-serif',
                }}
                onClick={() => window.open(`tel:${PHONE_DISPLAY.replace(/\s/g, '')}`)}>
                Call Now →
              </button>
            </div>

            {/* Email */}
            <div className="card" style={{ textAlign: 'center', padding: '36px 24px', borderTop: '4px solid var(--crimson)' }}>
              <div style={{ fontSize: 40, marginBottom: 12 }}>📧</div>
              <h3 style={{ color: 'var(--navy)', fontWeight: 800, fontSize: 17, marginBottom: 6 }}>Email</h3>
              <p style={{ color: 'var(--gray)', fontSize: 14, marginBottom: 18 }}>
                For detailed queries or documents — we reply within 24 hours.
              </p>
              <div style={{ fontWeight: 800, color: 'var(--navy)', fontSize: 14, marginBottom: 16 }}>{EMAIL}</div>
              <button
                className="btn-primary"
                onClick={() => window.open(`mailto:${EMAIL}`)}>
                Send Email →
              </button>
            </div>
          </div>

          {/* Hours + Location */}
          <div className="grid-2" style={{ marginBottom: 36 }}>
            <div className="card">
              <h3 style={{ color: 'var(--navy)', fontWeight: 800, fontSize: 17, marginBottom: 18 }}>🕐 Support Hours</h3>
              {[
                ['Monday – Friday', '9:00 AM – 8:00 PM'],
                ['Saturday', '9:00 AM – 6:00 PM'],
                ['Sunday', 'WhatsApp only (limited)'],
              ].map(([day, time]) => (
                <div key={day} style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid var(--border)' }}>
                  <span style={{ color: 'var(--gray)', fontSize: 14 }}>{day}</span>
                  <span style={{ fontWeight: 700, color: 'var(--navy)', fontSize: 14 }}>{time}</span>
                </div>
              ))}
              <div style={{ marginTop: 16, fontSize: 13, color: 'var(--gray)' }}>
                💬 For urgent queries outside hours, WhatsApp us — we try to reply as soon as possible.
              </div>
            </div>

            <div className="card">
              <h3 style={{ color: 'var(--navy)', fontWeight: 800, fontSize: 17, marginBottom: 18 }}>📍 Location</h3>
              <div style={{ color: 'var(--gray)', fontSize: 14, lineHeight: 1.75, marginBottom: 16 }}>
                <strong style={{ color: 'var(--navy)' }}>VRK Tech Academy</strong><br />
                {CITY}, India<br /><br />
                <em>Classes are conducted <strong>fully online</strong> via Google Meet / Zoom.
                No physical address visit needed — learn from anywhere!</em>
              </div>
              <div style={{ background: 'var(--gold-light)', borderRadius: 12, padding: '14px 16px', fontSize: 14, color: 'var(--navy)', fontWeight: 600 }}>
                🌐 100% Online · Join from any city in India
              </div>
            </div>
          </div>

          {/* Final CTA Banner */}
          <div style={{
            background: 'linear-gradient(135deg, #1B3A6B, #2A5298)',
            borderRadius: 24, padding: '44px 40px', textAlign: 'center', color: '#fff',
          }}>
            <h2 style={{ fontWeight: 900, fontSize: 26, marginBottom: 12 }}>
              📅 Ready to Start Learning?
            </h2>
            <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: 16, marginBottom: 28, lineHeight: 1.65 }}>
              The fastest way to get started is to register for the course batch. First class is demo and fee can be paid in the first 3 classes.
            </p>
            <div style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap' }}>
              <button className="btn-gold" style={{ fontSize: 16 }} onClick={() => navigate('/register')}>
                Register for Course →
              </button>
              <button className="btn-whatsapp" onClick={() => openWhatsApp()} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <img src="/whatsapp.png" alt="WhatsApp" style={{ height: 20, marginRight: 8 }} />
                WhatsApp Now
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
